"use strict";

var runInChildProcess = false;
  if (typeof window === 'undefined') {
    //runInChildProcess = true;
  }
// default digit reader is combined
var digitReader = require('./digit-reader-combined'),
  buildDigits = require('./build-digits'),
  debug = require('debug')('algorithm:general'),
  digitsIncrementChecker = require('./digits-increment-checker'),
  checkFlow = require('./check-flow'),
  digitsStack = require('./digits-stack');

module.exports.setLogger = function(logger) {
  debug = logger('algorithm:general');
  if (digitReader.setLogger) {
    digitReader.setLogger(logger);
  }
}


function getDecimalDigits(positions, result, propertyToCheck) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (propertyToCheck) {
      if (positions[i].precision < 1 && positions[i][propertyToCheck]) ret.push(result[i]);
    } else {
      if (positions[i].precision < 1) ret.push(result[i]);
    }
  }
  return ret;
}

function getIntegerDigits(positions, result, propertyToCheck) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (propertyToCheck) {
      if (positions[i].precision >= 1 && positions[i][propertyToCheck]) ret.push(result[i]);
    } else {
      if (positions[i].precision >= 1) ret.push(result[i]);
    }
  }
  return ret;
}

function getDecimalDigitHeights(positions, result) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (positions[i].precision < 1) {
      if (result[i].digitHeight) {
        ret.push(result[i].digitHeight);
      } else {
        ret.push(-1);
      }
    }
  }
  return ret;
}


function getIntegerDigitHeights(positions, result) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (positions[i].precision >= 1) {
      if (result[i].digitHeight) {
        ret.push(result[i].digitHeight);
      } else {
        ret.push(-1);
      }
    }
  }
  return ret;
}

function getDecimalDigitWidths(positions, result) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (positions[i].precision < 1) {
      if (result[i].digitWidth) {
        ret.push(result[i].digitWidth);
      } else {
        ret.push(-1);
      }
    }
  }
  return ret;
}


function getIntegerDigitWidths(positions, result) {
  var ret = [];
  for (var i = 0; i < positions.length; i++) {
    if (positions[i].precision >= 1) {
      if (result[i].digitWidth) {
        ret.push(result[i].digitWidth);
      } else {
        ret.push(-1);
      }
    }
  }
  return ret;
}


exports.analyzeImage = function(pixels, config, cb, debugImage) {
  /*
  this can be used for enabling digit algorithm to be changed at runtime */
  if (config.digits && config.digits.algoVersion === 'kamstrup_v1') {
    digitReader = require('./digitreader_kamstrup.js');
    digitsIncrementChecker.disable();
  } else if (config.digits && config.digits.algoVersion === 'digitsreader2') {
    try {
      digitReader = require('@smartvatten/digitreader2').getDigitReader({runInChildProcess:runInChildProcess});
      digitsIncrementChecker.disable();
    } catch (e) {console.log(e)}
  } else if (config.digits && config.digits.algoVersion === 'digitsreader1') {
    try {
      digitReader = require('@smartvatten/digitreader').getDigitReader({runInChildProcess:runInChildProcess});
      digitsIncrementChecker.disable();
    } catch (e) {console.log(e)}
  } else if(config.digits && config.digits.algoVersion === 'mlreader1'){
    try{
    digitReader=require('./mlreader1.js');
    digitsIncrementChecker.disable();
    }catch(err){
      console.log("Require mlreader ERROR:",err);
    }
  }else if(config.digits && config.digits.algoVersion === 'mlreaderjs'){
    try{
      digitReader=require('./mlreader2.js');
      digitsIncrementChecker.disable();
    }catch(err){
      console.error("Require mlreader2 ERROR:",err);
    }
  }


  var res = {};
  var err = null;
  if (console && console.profile) {
    console.profile("digitReader.analyzeImage");
  }
  try {
    digitReader.analyzeImage(pixels, config, function (err, result) {
      try {
        if(err){
            console.log("analyze image error:",err);
            throw err;
           }
        if (console && console.profile) {
          console.profileEnd();
        }

        if (Array.isArray(result.digits)) {
          // separate integers and decimals
          var integerDigits = getIntegerDigits(config.digits.positions, result.digits);
          var decimalDigits = getDecimalDigits(config.digits.positions, result.digits);
          res.integerDigitHeights = getIntegerDigitHeights(config.digits.positions, result.digits);
          res.decimalDigitHeights = getDecimalDigitHeights(config.digits.positions, result.digits);
          res.integerDigitWidths = getIntegerDigitWidths(config.digits.positions, result.digits);
          res.decimalDigitWidths = getDecimalDigitWidths(config.digits.positions, result.digits);

          if (integerDigits.length > 0) {
            res.integer = buildDigits.buildInteger(integerDigits, config);
            digitsIncrementChecker.clearAllowIncrementFlags(config.previousDigitsIntegerValue, res.integer.value);
            res.integer.historyLength = digitsStack.add(res.integer.value)
          }

          if (decimalDigits.length > 0) {
            res.decimal = buildDigits.buildDecimal(decimalDigits, config);
          }

          // compare incremented digitsDecimal value to digitsInteger value
          if (config.digits.algoVersion === 'kamstrup_v1') {
            if (
              res.integer &&
              res.decimal &&
              Math.floor(res.decimal) - Math.floor(config.previousDigitsDecimalValue) === 1 &&
              Math.floor(res.decimal) - Math.floor(res.integer) === 1
            ) {
              res.digits.decimal.errorCode = 4;
              res.digits.decimal.value = null;
            }
          }
        }
 
        if (result.height) res.height = result.height;
        if (result.width) res.width = result.width;
        if (result.data) res.data = result.data;
        res.digits = result.digits;
        res.canvas = result.canvas;
        res.flow = checkFlow(config, res);
        setTimeout(function() { cb(null, res); }, 1);
      } catch (error) {
        cb(error, {});
      }
    }, debugImage);
  } catch (error) {
    cb(error, {});
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/index.js
// module id = 843
// module chunks = 0